import { IconDefinition, faCircleCheck, faCircleXmark, faExclamation } from '@fortawesome/free-solid-svg-icons'

interface IStatusIconState {
  isError?: boolean
  isWarning?: boolean
  isSuccess?: boolean
}

/**
 * Which glyph each validation state shows. Shared so the inputs cannot drift
 * apart on it; the positioning and the color stay with each input's own styles.
 */
export const getStatusIcon = (state: IStatusIconState): IconDefinition | undefined => {
  if (state.isError) return faCircleXmark
  if (state.isWarning) return faExclamation
  if (state.isSuccess) return faCircleCheck
  return undefined
}
